import { Observable } from 'rxjs';
import { Size } from '../../Models/Geometry/Size';
import { Nullable } from '../../Utils/Types';

export class ImageWorker {
  protected createImageFromDataUrl(imageSource: string, size: Size): Observable<HTMLImageElement> {
    return new Observable((observer) => {
      const image = new Image();
      image.width = size.width;
      image.height = size.height;
      image.onload = (): void => {
        observer.next(image);
        observer.complete();
      };
      image.src = imageSource;
    });
  }

  protected createUrlFromImage(image: HTMLImageElement): string {
    const canvas: HTMLCanvasElement = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;

    const ctx: Nullable<CanvasRenderingContext2D> = canvas.getContext('2d');
    ctx?.drawImage(image, 0, 0, canvas.width, canvas.height);

    return canvas.toDataURL('image/png');
  }

  protected getImageSize(image: HTMLImageElement): Size {
    const { width, height } = image;
    return { width, height };
  }
}
